/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FamilyAndPrice } from './';
import {
    FamilyAndPriceFromJSON,
    FamilyAndPriceFromJSONTyped,
    FamilyAndPriceToJSON,
} from './';
import type { FamilyAndShare } from './';
import {
    FamilyAndShareFromJSON,
    FamilyAndShareFromJSONTyped,
    FamilyAndShareToJSON,
} from './';
import type { FreelancerPerYear } from './';
import {
    FreelancerPerYearFromJSON,
    FreelancerPerYearFromJSONTyped,
    FreelancerPerYearToJSON,
} from './';
import type { FreelancersPerArea } from './';
import {
    FreelancersPerAreaFromJSON,
    FreelancersPerAreaFromJSONTyped,
    FreelancersPerAreaToJSON,
} from './';
import type { Nav } from './';
import {
    NavFromJSON,
    NavFromJSONTyped,
    NavToJSON,
} from './';
import type { Range } from './';
import {
    RangeFromJSON,
    RangeFromJSONTyped,
    RangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface GeneralBarometer
 */
export interface GeneralBarometer {
    /**
     * 
     * @type {Array<Nav>}
     * @memberof GeneralBarometer
     */
    nav?: Array<Nav>;
    /**
     * 
     * @type {number}
     * @memberof GeneralBarometer
     */
    nbFreelancers: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralBarometer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBarometer
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBarometer
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBarometer
     */
    mapArea?: string;
    /**
     * 
     * @type {Array<FreelancersPerArea>}
     * @memberof GeneralBarometer
     */
    freelancersPerAreas: Array<FreelancersPerArea>;
    /**
     * 
     * @type {Array<Range>}
     * @memberof GeneralBarometer
     */
    areaSizeRange: Array<Range>;
    /**
     * 
     * @type {number}
     * @memberof GeneralBarometer
     */
    shareOfMen: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralBarometer
     */
    shareOfWomen: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralBarometer
     */
    nbSearchLastMonth: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralBarometer
     */
    averageRating: number;
    /**
     * 
     * @type {Array<FamilyAndPrice>}
     * @memberof GeneralBarometer
     */
    familyAndPrices: Array<FamilyAndPrice>;
    /**
     * 
     * @type {string}
     * @memberof GeneralBarometer
     */
    priceTitle?: string;
    /**
     * 
     * @type {Array<FreelancerPerYear>}
     * @memberof GeneralBarometer
     */
    freelancerPerYears?: Array<FreelancerPerYear>;
    /**
     * 
     * @type {Array<FamilyAndShare>}
     * @memberof GeneralBarometer
     */
    familyAndShares: Array<FamilyAndShare>;
}

/**
 * Check if a given object implements the GeneralBarometer interface.
 */
export function instanceOfGeneralBarometer(value: object): value is GeneralBarometer {
    if (!('nbFreelancers' in value) || value['nbFreelancers'] === undefined) return false;
    if (!('freelancersPerAreas' in value) || value['freelancersPerAreas'] === undefined) return false;
    if (!('areaSizeRange' in value) || value['areaSizeRange'] === undefined) return false;
    if (!('shareOfMen' in value) || value['shareOfMen'] === undefined) return false;
    if (!('shareOfWomen' in value) || value['shareOfWomen'] === undefined) return false;
    if (!('nbSearchLastMonth' in value) || value['nbSearchLastMonth'] === undefined) return false;
    if (!('averageRating' in value) || value['averageRating'] === undefined) return false;
    if (!('familyAndPrices' in value) || value['familyAndPrices'] === undefined) return false;
    if (!('familyAndShares' in value) || value['familyAndShares'] === undefined) return false;
    return true;
}

export function GeneralBarometerFromJSON(json: any): GeneralBarometer {
    return GeneralBarometerFromJSONTyped(json, false);
}

export function GeneralBarometerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneralBarometer {
    if (json == null) {
        return json;
    }
    return {
        
        'nav': json['nav'] == null ? undefined : ((json['nav'] as Array<any>).map(NavFromJSON)),
        'nbFreelancers': json['nbFreelancers'],
        'title': json['title'] == null ? undefined : json['title'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'mapArea': json['mapArea'] == null ? undefined : json['mapArea'],
        'freelancersPerAreas': ((json['freelancersPerAreas'] as Array<any>).map(FreelancersPerAreaFromJSON)),
        'areaSizeRange': ((json['areaSizeRange'] as Array<any>).map(RangeFromJSON)),
        'shareOfMen': json['shareOfMen'],
        'shareOfWomen': json['shareOfWomen'],
        'nbSearchLastMonth': json['nbSearchLastMonth'],
        'averageRating': json['averageRating'],
        'familyAndPrices': ((json['familyAndPrices'] as Array<any>).map(FamilyAndPriceFromJSON)),
        'priceTitle': json['priceTitle'] == null ? undefined : json['priceTitle'],
        'freelancerPerYears': json['freelancerPerYears'] == null ? undefined : ((json['freelancerPerYears'] as Array<any>).map(FreelancerPerYearFromJSON)),
        'familyAndShares': ((json['familyAndShares'] as Array<any>).map(FamilyAndShareFromJSON)),
    };
}

export function GeneralBarometerToJSON(value?: GeneralBarometer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nav': value['nav'] == null ? undefined : ((value['nav'] as Array<any>).map((v) => NavToJSON(v))),
        'nbFreelancers': value['nbFreelancers'],
        'title': value['title'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'mapArea': value['mapArea'],
        'freelancersPerAreas': ((value['freelancersPerAreas'] as Array<any>).map((v) => FreelancersPerAreaToJSON(v))),
        'areaSizeRange': ((value['areaSizeRange'] as Array<any>).map((v) => RangeToJSON(v))),
        'shareOfMen': value['shareOfMen'],
        'shareOfWomen': value['shareOfWomen'],
        'nbSearchLastMonth': value['nbSearchLastMonth'],
        'averageRating': value['averageRating'],
        'familyAndPrices': ((value['familyAndPrices'] as Array<any>).map((v) => FamilyAndPriceToJSON(v))),
        'priceTitle': value['priceTitle'],
        'freelancerPerYears': value['freelancerPerYears'] == null ? undefined : ((value['freelancerPerYears'] as Array<any>).map((v) => FreelancerPerYearToJSON(v))),
        'familyAndShares': ((value['familyAndShares'] as Array<any>).map((v) => FamilyAndShareToJSON(v))),
    };
}

